const GridBg = () => {
  return (
    <div
      className='absolute inset-0 bg-[length:40px_40px] bg-[rgba(255,255,246,0.1)] [mask-image:radial-gradient(circle,rgba(0,0,0,0.5),transparent)]'
      style={{
        backgroundImage:
          'repeating-linear-gradient(to right, rgba(255,255,246,0.4) 0px, rgba(255,255,246,0.4) 1px, transparent 1px, transparent 40px), repeating-linear-gradient(to bottom, rgba(255,255,246,0.4) 0px, rgba(255,255,246,0.4) 1px, transparent 1px, transparent 40px)',
      }}>
      <div className='absolute inset-0 bg-gradient-to-b from-background/40 to-background -z-10' />
    </div>
  );
};

export default GridBg;
